import { useEffect, useState, useCallback } from 'react';
import { loadMyTasks, buildReminders, getDismissed, dismissReminder, isDismissedToday, setTaskHash } from '../lib/tasks';

const COL = {
  late:  { bg: '#FDECEA', bd: '#F2B8B5', dot: '#B3261E' },
  final: { bg: '#FDECEA', bd: '#F2B8B5', dot: '#B3261E' },
  mid:   { bg: '#FFF3D6', bd: '#F0D58A', dot: '#C27A00' },
};

// Баннеры-напоминания над содержимым страницы; onOpen(taskId) — открыть задачу во вкладке «Мои задачи»
export default function TaskBanners({ userId, onOpen, refreshKey }) {
  const [items, setItems] = useState([]);
  const [dis, setDis] = useState(() => getDismissed(userId));
  const load = useCallback(async () => {
    try { const { tasks, subs } = await loadMyTasks(userId); setItems(buildReminders(tasks, subs, userId)); } catch (e) {}
  }, [userId]);
  useEffect(() => { load(); const t = setInterval(load, 120000); return () => clearInterval(t); }, [load, refreshKey]);
  const shown = items.filter(i => !isDismissedToday(dis, i.key));
  if (!shown.length) return null;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 8 }}>
      {shown.map(i => { const c = COL[i.kind]; return (
        <div key={i.key} style={{ display: 'flex', alignItems: 'center', gap: 10, background: c.bg, border: `1px solid ${c.bd}`, borderRadius: 12, padding: '6px 12px' }}>
          <span style={{ width: 10, height: 10, borderRadius: '50%', background: c.dot, flex: 'none' }} />
          <span style={{ flex: 1, fontSize: 12.5 }}>{i.text}</span>
          <button onClick={() => { setTaskHash(i.task.id); onOpen(i.task.id); }} style={{ background: 'none', border: 'none', color: '#2E75B6', fontWeight: 600, fontSize: 13, cursor: 'pointer' }}>Открыть</button>
          <button onClick={() => { dismissReminder(userId, i.key); setDis(getDismissed(userId)); }} style={{ background: 'none', border: 'none', color: '#7A869C', fontSize: 18, cursor: 'pointer', lineHeight: 1 }}>×</button>
        </div>); })}
    </div>
  );
}
